import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/omit';
import Icon from '../icon';
import Ripple from '../ripple';
import { Size } from '../_util/enum';
import { ProgressType } from '../progress/enum';
import Progress from '../progress';
import ConfigContext from '../config-provider/ConfigContext';
export default class Button extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = e => {
            clearTimeout(this.timeout);
            this.timeout = window.setTimeout(() => this.setState({ clicked: false }), 500);
            const { onClick } = this.props;
            if (onClick) {
                onClick(e);
            }
        };
        this.state = {
            loading: props.loading,
            clicked: false,
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    componentWillReceiveProps(nextProps) {
        const { loading: currentLoading } = this.props;
        const { loading } = nextProps;
        if (currentLoading) {
            clearTimeout(this.delayTimeout);
        }
        if (typeof loading !== 'boolean' && loading && loading.delay) {
            this.delayTimeout = window.setTimeout(() => this.setState({ loading }), loading.delay);
        }
        else {
            this.setState({ loading });
        }
    }
    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }
    }
    render() {
        const { prefixCls: customizePrefixCls, type, shape, size, className, htmlType, children, icon, ghost, funcType, onMouseEnter, onMouseLeave, disabled, ...others } = this.props;
        const { loading, clicked } = this.state;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('btn', customizePrefixCls);
        // large => lg
        // small => sm
        let sizeCls = '';
        switch (size) {
            case Size.large:
                sizeCls = 'lg';
                break;
            case Size.small:
                sizeCls = 'sm';
                break;
            default:
        }
        const ComponentProp = others.href ? 'a' : 'button';
        const classes = classNames(prefixCls, className, {
            [`${prefixCls}-${type}`]: type,
            [`${prefixCls}-${shape}`]: shape,
            [`${prefixCls}-${sizeCls}`]: sizeCls,
            [`${prefixCls}-icon-only`]: !children && icon,
            [`${prefixCls}-loading`]: loading,
            [`${prefixCls}-clicked`]: clicked,
            [`${prefixCls}-background-ghost`]: ghost,
            [`${prefixCls}-${funcType}`]: funcType,
        });
        let iconNode = icon ? React.createElement(Icon, { type: icon }) : null;
        iconNode = loading ? (React.createElement(Progress, { key: "loading", type: ProgressType.loading, size: Size.small })) : (iconNode);
        const kids = children || children === 0
            ? Children.map(children, child => {
                if (typeof child === 'string') {
                    return React.createElement("span", null, child);
                }
                return child;
            })
            : null;
        const useWrapper = disabled && ComponentProp === 'button' && (onMouseEnter || onMouseLeave);
        const { style, ...otherProps } = others;
        const button = (React.createElement(Ripple, { disabled: disabled },
            React.createElement(ComponentProp, Object.assign({ disabled: disabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, omit(otherProps, ['loading']), { 
                // 如果没有href属性，则表示组件使用button标签，type为'submit' | 'reset' | 'button'
                type: others.href ? undefined : htmlType || 'button', style: useWrapper ? undefined : style, className: useWrapper ? undefined : classes, onClick: this.handleClick }),
                iconNode,
                kids)));
        return useWrapper ? (React.createElement("span", { 
            // @ts-ignore
            disabled: true, style: style, className: classNames(classes, `${prefixCls}-disabled-wrapper`), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, button)) : button;
    }
}
Button.displayName = 'Button';
Button.__C7N_BUTTON = true;
Button.defaultProps = {
    loading: false,
    ghost: false,
    funcType: 'flat',
};
Button.propTypes = {
    type: PropTypes.string,
    shape: PropTypes.oneOf(['circle', 'circle-outline']),
    size: PropTypes.oneOf([Size.large, Size.default, Size.small]),
    htmlType: PropTypes.oneOf(['submit', 'button', 'reset']),
    onClick: PropTypes.func,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    className: PropTypes.string,
    icon: PropTypes.string,
    ghost: PropTypes.bool,
    funcType: PropTypes.oneOf(['raised', 'flat']),
};
